import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component(r) {
        require.ensure(['@/pages/index'], () => {
          r(require('@/pages/index'))
        })
      }
    },
    {
      path: '/success',
      name: 'success',
      component(r) {
        require.ensure(['@/pages/success'], () => {
          r(require('@/pages/success'))
        })
      }
    },
    {
      path: '/content',
      name: 'content',
      component(r) {
        require.ensure(['@/pages/content'], () => {
          r(require('@/pages/content'))
        })
      }
    },
    // {
    //   path: '/order',
    //   name: 'order',
    //   component(r) {
    //     require.ensure(['@/pages/order'], () => {
    //       r(require('@/pages/order'))
    //     })
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js